module.exports = __webpack_public_path__ + "static/media/workspace.36453e4d.svg";